import { render, staticRenderFns } from "./Lgx279924608939851776.vue?vue&type=template&id=2037d7a6&"
import script from "./Lgx279924608939851776.vue?vue&type=script&lang=js&"
export * from "./Lgx279924608939851776.vue?vue&type=script&lang=js&"
import style0 from "./Lgx279924608939851776.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports